import { FC } from 'react';
import { Box, BoxProps, Flex, Skeleton, Text } from '@chakra-ui/react';
import ArrowLeft from '../Icons/ArrowLeft';
export interface CbManageHeaderSkeletonProps extends BoxProps {
  hasBackArrow: boolean;
  componentColor: string;
  colorScheme?: string;
}
export const CbManageHeaderSkeleton: FC<CbManageHeaderSkeletonProps> = ({
  colorScheme,
  hasBackArrow,
  componentColor,
  ...props
}) => {
  return <Box backgroundColor={colorScheme} borderBottomRadius={{
    base: 24
  }} display="flex" justifyContent="space-between" paddingX={{
    base: 4,
    lg: 6
  }} paddingTop={{
    base: 10,
    md: '80px'
  }} paddingBottom={{
    base: 4,
    md: 6
  }} alignItems={'start'} flexWrap={'wrap'} {...props} data-sentry-element="Box" data-sentry-component="CbManageHeaderSkeleton" data-sentry-source-file="CbManageHeaderSkeleton.tsx">
      <Flex alignItems={'center'} data-sentry-element="Flex" data-sentry-source-file="CbManageHeaderSkeleton.tsx">
        {hasBackArrow && <Box display="flex" alignItems="center" as="button" aria-label="Go Back" height={10} width={10} opacity="0.6" textAlign="left" _hover={{
        opacity: '1'
      }}>
            <ArrowLeft color={componentColor} />
          </Box>}
        <Box data-sentry-element="Box" data-sentry-source-file="CbManageHeaderSkeleton.tsx">
          <Skeleton marginBottom={2} data-sentry-element="Skeleton" data-sentry-source-file="CbManageHeaderSkeleton.tsx">
            <Text as="h1" fontSize={'2xl'} fontFamily="codenext" color={componentColor} fontWeight="bold" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="CbManageHeaderSkeleton.tsx">
              {'Phillip T. Skeleton VII'}
            </Text>
          </Skeleton>
          <Skeleton data-sentry-element="Skeleton" data-sentry-source-file="CbManageHeaderSkeleton.tsx">
            <Text fontFamily="codenext" fontSize={{
            base: 'xl',
            md: 'lg'
          }} color={componentColor} data-sentry-element="Text" data-sentry-source-file="CbManageHeaderSkeleton.tsx">
              {'Dashboard'}
            </Text>
          </Skeleton>
        </Box>
      </Flex>
    </Box>;
};